var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPaperclip = function SvgPaperclip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.126 1.251 0 6.699l.828.88L5.955 2.13a2.743 2.743 0 0 1 4.04 0c1.112 1.183 1.112 3.11 0 4.292L7.398 9.181l-.002-.001-2.835 3.012a1.771 1.771 0 0 1-2.55 0 1.964 1.964 0 0 1-.53-1.354c0-.512.188-.993.53-1.356l1.703-1.81h.001L7.22 3.95a.671.671 0 0 1 .964 0 .76.76 0 0 1 0 1.024L3.532 9.917l.829.88 4.652-4.942c.721-.768.721-2.018 0-2.786-.7-.742-1.923-.743-2.621 0L3.529 6.112l-.001-.001-2.344 2.491a3.243 3.243 0 0 0-.872 2.237c0 .844.31 1.638.872 2.235.562.596 1.31.926 2.104.926.795 0 1.542-.329 2.103-.926l2.53-2.689.002.003 2.901-3.082c1.568-1.67 1.568-4.385 0-6.053-1.572-1.67-4.126-1.67-5.698-.002Z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

export default SvgPaperclip;